import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import reducer from './reducer';


export default function buildStore(state = {}){
	const middleware = [thunk];
	const localStoragePaths = [
		"live", // contents from websockets live connection
		"query", // results of oql query requests
		"queryArgs", // saves state of form submissions
		"history", // history for query contents (CACHE )
		"config", // configurtion like number of live top posts
		"wordpress", // contents coming from wordpress
	];
	const enhancers = (typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "function")?
		compose(
			applyMiddleware(...middleware),
			persistState(localStoragePaths),
			window.__REDUX_DEVTOOLS_EXTENSION__()
		)
		:
		compose(applyMiddleware(...middleware), persistState(localStoragePaths));
	return createStore(
		reducer,
		state,
		enhancers
	);
}